export default __webpack_public_path__ + "static/media/kouteki_web_title.2b353c68.png";